import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';

class Summit extends Component {

    render() {
        const { t } = this.props;
        return (
            <div className="row-auto">
                <form method="post" onSubmit={this.props.handleSummit}>
                    {/* <div className="form-group col-md-12">
                        <h2 className="form-group-title">Datos Personales</h2>
                    </div> */}
                    <div className="form-group col-md-6 col-xs-6">
                        <label htmlFor="center">
                            Folio
                        </label>
                        <input
                            disabled={true}
                            readOnly
                            className="form-control"
                            id="info_summit"
                            value={this.props.folio ? this.props.folio : ''}
                            type="text" />
                    </div>
                    <div className="form-group col-md-6 col-xs-6">
                        <label htmlFor="center">
                            Nombre
                        </label>
                        <input
                            disabled={true}
                            className="form-control"
                            id="name_summit"
                            value={this.props.fullname ? this.props.fullname : ''}
                            type="text"
                            onChange={this.props.handleChanegeName} />
                    </div>
                    <div className="form-group col-md-6 col-sm-12">
                        <label htmlFor="center">
                            Correo
                        </label>
                        <input
                            disabled={true}
                            className="form-control"
                            id="email_summit"
                            value={this.props.correo ? this.props.correo : ''}
                            type="text" />
                    </div>
                    <div className="form-group  col-md-2 col-xs-6">
                        <label htmlFor="center">
                            Edad
                        </label>
                        <input
                            disabled={true}
                            className="form-control"
                            id="year_summit"
                            value={this.props.edad ? this.props.edad : ''}
                            type="text" />
                    </div>
                    <div className="form-group  col-md-4 col-xs-6">
                        <label htmlFor="center">
                            Género
                        </label>
                        <input
                            disabled={true}
                            className="form-control"
                            id="geneder_summit"
                            value={this.props.genero ? this.props.genero : ''}
                            type="text" />
                    </div>
                    <div className="form-group  col-xs-6">
                        <label htmlFor="center">
                            Estado
                        </label>
                        <input
                            disabled={true}
                            className="form-control"
                            id="business_summit"
                            value={this.props.estado ? this.props.estado : ''}
                            type="text" />
                    </div>
                    <div className="form-group col-xs-6">
                        <label htmlFor="center">
                            Ciudad
                        </label>
                        <input
                            disabled={true}
                            className="form-control"
                            id="business_summit"
                            value={this.props.cuidad ? this.props.cuidad : ""}
                            type="text" />
                    </div>
                    <div className="form-group  col-md-6 col-xs-6">
                        <label htmlFor="center">
                            Nombre de la Empresa
                        </label>
                        <input
                            disabled={true}
                            className="form-control"
                            id="empresa_summit"
                            value={this.props.empresaName ? this.props.empresaName : ''}
                            type="text" />
                    </div>
                    <div className="form-group col-md-6 col-xs-6">
                        <label htmlFor="center">
                            Puesto
                        </label>
                        <input
                            disabled={true}
                            className="form-control"
                            id="puesto_summit"
                            value={this.props.puesto ? this.props.puesto : ""}
                            type="text" />
                    </div>
                    <div className="form-group col-md-12">
                        <div className="form-group-button">
                            {this.props.isMember ? (
                                <button
                                    className="btn btn-primary btn-full-width"
                                    type="submit">
                                    Registar Asistencia
                                </button>
                            ) : null}
                        </div>
                    </div>
                </form >
            </div >
        )
    }
}

export default translate('common')(Summit);


// WEBPACK FOOTER //
// ./src/guest/summit_asistencia/Summit.js